/**
 * Who is on duty, from Dialpad's agent status events. Pure.
 *
 * Off duty is not one of Dialpad's status words: an agent is off duty when they are on duty for no
 * call center (`call_center_ids` empty). The newest change (`date`) wins, so out-of-order and
 * repeated deliveries cannot flip anyone back.
 *
 * A ticket is covered when anyone holding it is on duty. A holder the desk cannot see (not a
 * Dialpad agent, or not on the team list) counts as off duty, so a ticket never reads as covered by
 * someone nobody can check on.
 */
const WORDS = {
    available: 'available',
    busy: 'busy',
    occupied: 'on_call',
    wrapup: 'wrapup',
    unavailable: 'unavailable',
};
const LABELS = {
    available: 'Available',
    busy: 'Busy',
    on_call: 'On a call',
    wrapup: 'Wrap-up',
    unavailable: 'Unavailable',
    off_duty: 'Off duty',
};
const isRecord = (v) => typeof v === 'object' && v !== null;
const str = (v) => (typeof v === 'string' && v.trim() !== '' ? v.trim() : null);
export function presenceFromEvent(payload) {
    if (!isRecord(payload) || !isRecord(payload['target']))
        return null;
    const target = payload['target'];
    if (target['type'] !== 'user')
        return null;
    const email = str(target['email'])?.toLowerCase();
    const at = payload['date'];
    if (!email || typeof at !== 'number')
        return null;
    const centers = payload['call_center_ids'];
    const onDuty = Array.isArray(centers) && centers.length > 0;
    const status = str(payload['on_duty_status'])?.toLowerCase() ?? '';
    const id = target['id'];
    return {
        email,
        dialpadUserId: typeof id === 'number' || typeof id === 'string' ? String(id) : null,
        name: str(target['name']),
        onDuty,
        word: onDuty ? (WORDS[status] ?? 'available') : 'off_duty',
        reason: str(payload['on_duty_status_reason']),
        at,
    };
}
export function foldPresence(current, next) {
    if (current && next.at <= current.at)
        return { next: current, changed: false };
    return { next, changed: true };
}
export function presenceLabel(word) {
    return LABELS[word];
}
export function ticketHolders(t) {
    if (t.assignee)
        return [t.assignee];
    const seen = new Set();
    return t.supportTeam.filter((h) => {
        const key = h.email || `name:${h.name}`;
        if (seen.has(key))
            return false;
        seen.add(key);
        return true;
    });
}
export function coverage(holders, presence) {
    const first = holders[0];
    if (!first)
        return { kind: 'none' };
    const on = holders.find((h) => h.email !== '' && presence(h.email)?.onDuty === true);
    return on ? { kind: 'covered', name: on.name } : { kind: 'off_duty', name: first.name };
}
export function needsOwner(c) {
    return c.kind !== 'covered';
}
//# sourceMappingURL=presence.js.map